import { lazy } from 'react'
import { RouteProps } from 'react-router'
export interface PrivateRouteObject extends RouteProps {
  exact: boolean
  path: string
  breadcrumb?: string
  component: any
  title: string
  hideSideBar?: boolean
}

const Profile = lazy(() => import('../containers/Profile'))
const Authentication = lazy(() => import('../containers/Authentication'))
const ConfirmEmail = lazy(() => import('../containers/ConfirmEmail'))
const ForgotPassword = lazy(() => import('../containers/ForgotPassword'))
const ResetPassword = lazy(() => import('../containers/ResetPassword'))
const Homepage = lazy(() => import('../containers/Homepage'))
const RoleSelect = lazy(() => import('../containers/RoleSelect'))
const ConfirmedScreen = lazy(() => import('../containers/ConfirmedScreen'))
const CorporateOnboarding = lazy(() => import('../containers/CorporateOnboarding'))
const Notes = lazy(() => import('../containers/Notes'))
const MasterNotes = lazy(() => import('../containers/MasterNotes'))
const NotesCreate = lazy(() => import('../containers/NoteCreate'))
const MasterNote = lazy(() => import('../containers/MasterNote'))
const InvestorOnboarding = lazy(() => import('../containers/InvestorOnboarding'))
const NoteDetailView = lazy(() => import('../containers/NoteDetailView'))
const MasterNoteDetailView = lazy(() => import('../containers/MasterNoteDetailView'))
const Dashboard = lazy(() => import('../containers/Dashboard'))
const Notifications = lazy(() => import('../containers/RegulatoryBody/Notifications'))
const HelpAndSupport = lazy(() => import('containers/HelpAndSupport'))
const FAQs = lazy(() => import('../containers/FAQs'))
const Trade = lazy(() => import('../containers/Trade'))
const AiChat = lazy(() => import('../containers/AiChat'))
const RealEstateAssets = lazy(() => import('../containers/RealEstateAssets'))
const RealEstateCreate = lazy(() => import('../containers/RealEstateCreate'))
const RealEstateAssetDetailView = lazy(() => import('../containers/RealEstateAssetDetailView'))
const MasterBonds = lazy(() => import('../containers/MasterAssets'))
const MasterBondCreate = lazy(() => import('../containers/MasterAssetCreate'))
const MasterBondDetailView = lazy(() => import('../containers/MasterAssetDetailView'))
const Bonds = lazy(() => import('../containers/Bonds'))
const BondCreate = lazy(() => import('../containers/BondCreate'))
const BondDetailView = lazy(() => import('../containers/BondDetailView'))

const SHARED_ROUTES: PrivateRouteObject[] = [
  {
    exact: true,
    title: 'Help & Support',
    path: '/auth/help-and-support',
    component: HelpAndSupport
  }
]

const PRIVATE_ROUTES: PrivateRouteObject[] = [
  {
    exact: false,
    path: '/auth/my-dashboard',
    breadcrumb: 'My Dashboard',
    component: Dashboard,
    title: 'My Dashboard'
  },
  {
    exact: false,
    path: '/auth/profile',
    breadcrumb: 'My Profile',
    component: Profile,
    title: 'My Profile'
  },
  {
    exact: true,
    title: 'Main Onboarding',
    path: '/auth/main-onboarding',
    component: RoleSelect,
    hideSideBar: true
  },
  {
    exact: true,
    title: 'Corporate Onboarding',
    path: '/auth/corporate-onboarding',
    component: CorporateOnboarding
  },
  {
    exact: true,
    title: 'My Notes',
    path: '/auth/notes',
    component: Notes
  },
  {
    exact: true,
    title: 'My Real Estate Assets',
    path: '/auth/real-estate-assets',
    component: RealEstateAssets
  },
  {
    exact: false,
    title: 'Create real estate asset',
    path: '/auth/real-estate-assets/create/:step/:id?',
    breadcrumb: 'Create real estate asset',
    component: RealEstateCreate,
    hideSideBar: true
  },
  {
    exact: true,
    title: 'My Master Notes',
    path: '/auth/master-notes',
    component: MasterNotes
  },
  {
    exact: false,
    title: 'Create note',
    path: '/auth/note/create/:step/:id?',
    breadcrumb: 'Create note',
    component: NotesCreate,
    hideSideBar: true
  },
  {
    exact: false,
    title: 'Create master note',
    path: '/auth/masternote/create/:step/:id?',
    breadcrumb: 'Create note',
    component: MasterNote,
    hideSideBar: true
  },
  {
    exact: true,
    title: 'Notifications',
    path: '/auth/notifications',
    component: Notifications
  },
  {
    exact: true,
    title: 'Investor Onboarding',
    path: '/auth/investor-onboarding',
    component: InvestorOnboarding
  },
  {
    exact: true,
    title: 'My note details',
    path: '/auth/notes/:view/:id',
    component: NoteDetailView
  },
  {
    exact: true,
    title: 'My Master Note Details',
    path: '/auth/master-note/:id',
    component: MasterNoteDetailView
  },
  {
    exact: true,
    title: 'My Real Estate Asset Details',
    path: '/auth/my-real-estate-assets/:view/:id',
    component: RealEstateAssetDetailView
  },
  {
    exact: true,
    title: 'My Master Bonds',
    path: '/auth/master-bonds',
    component: MasterBonds
  },
  {
    exact: false,
    title: 'Create master bond',
    path: '/auth/master-bonds/create/:step/:id?',
    breadcrumb: 'Create master bond',
    component: MasterBondCreate,
    hideSideBar: true
  },
  {
    exact: true,
    title: 'My Master Bond Details',
    path: '/auth/my-master-bonds/:view/:id',
    component: MasterBondDetailView
  },
  {
    exact: true,
    title: 'My Bonds',
    path: '/auth/bonds',
    component: Bonds
  },
  {
    exact: false,
    title: 'Create bond',
    path: '/auth/bonds/create',
    breadcrumb: 'Create bond',
    component: BondCreate
  },
  {
    exact: true,
    title: 'My Bond Details',
    path: '/auth/my-bonds/:view/:id',
    component: BondDetailView
  },
  ...SHARED_ROUTES
]

const PUBLIC_ROUTES = [
  {
    exact: true,
    title: 'Login',
    path: '/login',
    component: Authentication
  },
  {
    exact: true,
    title: 'Register',
    path: '/register',
    component: Authentication
  },
  {
    exact: true,
    title: 'Confirm Email',
    path: '/confirm-email',
    component: ConfirmEmail
  },
  {
    exact: true,
    title: 'Forgot Password',
    path: '/forgot-password',
    component: ForgotPassword
  },
  {
    exact: true,
    title: 'Reset Password',
    path: '/reset-password',
    component: ResetPassword
  },
  {
    exact: true,
    title: 'Create Password',
    path: '/create-password',
    component: ResetPassword
  },
  {
    exact: true,
    title: 'Homepage',
    path: '/',
    component: Homepage
  },
  {
    exact: true,
    title: 'Account Confirmed',
    path: '/confirmed',
    component: ConfirmedScreen
  },
  {
    exact: true,
    title: 'FAQs',
    path: '/faqs',
    component: FAQs
  },
  {
    exact: true,
    title: 'AI Assistant',
    path: '/ai-assistant',
    component: AiChat
  },
  {
    exact: true,
    title: 'JamiiPesa Trade',
    path: '/trade',
    component: Trade
  }
]

const AUTH_ROUTES: PrivateRouteObject[] = [
  {
    exact: true,
    title: 'Main Onboarding',
    path: '/auth/main-onboarding',
    component: RoleSelect,
    hideSideBar: true
  }
]

export { AUTH_ROUTES, PRIVATE_ROUTES, PUBLIC_ROUTES, SHARED_ROUTES }
